import { call } from "redux-saga/effects";
import { takeLatest } from "redux-saga/effects";
import { API_URL, SAGA_ACTIONS, sagaFunction } from "../_config";
import { CallApi } from "./api/callApi";

function* getAdminUsers(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.ADMIN_USERS.LIST, action.payload, true);
}

function* createAdminUser(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.ADMIN_USERS.CREATE, action.payload, true);
}

function* updateAdminUser(action: any): any {
  const { id, ...rest } = action.payload || {};
  const url = API_URL.ADMIN_USERS.UPDATE(id);
  yield call(sagaFunction, { ...action, payload: rest }, CallApi.PUT, url, rest, true);
}

function* deactivateAdminUser(action: any): any {
  const { id, ...rest } = action.payload || {};
  const url = API_URL.ADMIN_USERS.DEACTIVATE(id);
  yield call(sagaFunction, { ...action, payload: rest }, CallApi.POST, url, rest, true);
}

export default function* adminUsersSaga() {
  yield takeLatest(SAGA_ACTIONS.ADMIN.USERS.LIST, getAdminUsers);
  yield takeLatest(SAGA_ACTIONS.ADMIN.USERS.CREATE, createAdminUser);
  yield takeLatest(SAGA_ACTIONS.ADMIN.USERS.UPDATE, updateAdminUser);
  yield takeLatest(SAGA_ACTIONS.ADMIN.USERS.DEACTIVATE, deactivateAdminUser);
}
